// Guards for ProductApplication types

import {
    ProductApplication,
    ProductApplicationSegment,
    ProductApplicationSegmentApplication,
} from '../types/ProductApplication';

export function isProductApplicationSegment(
    application: ProductApplication
): application is ProductApplicationSegment {
    return (application as ProductApplicationSegment).children !== undefined;
}

export function isProductApplicationSegmentApplication(
    application: ProductApplication
): application is ProductApplicationSegmentApplication {
    return (application as ProductApplicationSegmentApplication).parent !== undefined;
}
